import { useMutation } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import { reportUnexpectedError } from '../../../lib/reportError'
import { isDeviceForbiddenError } from '../../../lib/deviceAuthError'

interface VerifyCurrentCashierPinResult {
  success?: boolean
  cashierId?: string
  error?: string
}

export class InvalidCashierPinError extends Error {
  constructor() {
    super('invalid_pin')
  }
}

async function verifyCurrentCashierPin(pin: string): Promise<string> {
  const { data, error } = await supabase.functions.invoke<VerifyCurrentCashierPinResult>(
    'verify-current-cashier-pin',
    { body: { pin } },
  )

  if (error || data?.error === 'internal_server_error') {
    const failure = error ?? new Error('verify_current_cashier_pin_failed')
    if (!isDeviceForbiddenError(failure)) reportUnexpectedError(failure)
    throw failure
  }

  if (data?.success !== true || !data.cashierId) {
    throw new InvalidCashierPinError()
  }

  return data.cashierId
}

export function useVerifyCurrentCashierPin() {
  return useMutation({ mutationFn: verifyCurrentCashierPin })
}
